import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosPatch,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllSupportTicketResponse,
  getOldMessagesResponse,
  getSupportTicketByIdResponse,
  getSupportTicketsByStatusResponse,
} from "../actions";

export function* createSupportTicketEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`support-tickets`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "SupportTickets saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllSupportTicketEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`support-tickets/all`));
    yield put(getAllSupportTicketResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllSupportTicketResponse([]));
  }
}

export function* getSupportTicketByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`support-tickets/1`));
    yield put(getSupportTicketByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getSupportTicketByIdResponse([]));
  }
}

export function* updateSupportTicketEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(
        `support-tickets/${action?.data?.payload?.id}`,
        action.data?.payload
      )
    );
    action.data?.callback?.success?.(data);
    // toast.success(data?.message || "SupportTickets updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) {
      action.data?.callback?.failure?.(e);
      // toast.error(e?.data?.message || "SupportTickets updation failed");
    }
  }
}

export function* deleteSupportTicketEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`support-tickets/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "SupportTickets deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getSupportTicketsByStatusEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`support-tickets/status/5`));
    yield put(getSupportTicketsByStatusResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getSupportTicketsByStatusResponse([]));
  }
}

export function* addChatMessageEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`support-tickets/add-chat/6`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "SupportTickets saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}
export function* getOldMessagesEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(`support-tickets/chats/${action?.payload?.id}`)
    );

    yield put(getOldMessagesResponse(data));
    action.payload?.callback?.success?.(data);

    // toast.success(data?.message || "SupportTickets saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}
export function* updateUnseenChatEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(
        `/support-tickets/addSeenTime/${action?.data?.payload?.id}?type=${action?.data?.payload?.type}`
      )
    );

    action?.data?.callback?.success?.(data);

    // toast.success(data?.message || "SupportTickets saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* endChatSessionEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(
        `/support-tickets/endChatSession/${action.data?.payload?.status}`,
        action.data?.payload?.message
      )
    );

    action?.data?.callback?.success?.(data);

    // toast.success(data?.message || "SupportTickets saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* supportTicketsWatcherSaga() {
  yield takeLatest(types.CREATE_SUPPORT_TICKET, createSupportTicketEffectSaga);
  yield takeLatest(types.GET_ALL_SUPPORT_TICKET, getAllSupportTicketEffectSaga);
  yield takeLatest(
    types.GET_SUPPORT_TICKET_BY_ID,
    getSupportTicketByIdEffectSaga
  );
  yield takeLatest(types.UPDATE_SUPPORT_TICKET, updateSupportTicketEffectSaga);
  yield takeLatest(types.DELETE_SUPPORT_TICKET, deleteSupportTicketEffectSaga);
  yield takeLatest(
    types.GET_SUPPORT_TICKETS_BY_STATUS,
    getSupportTicketsByStatusEffectSaga
  );
  yield takeLatest(types.ADD_CHAT_MESSAGE, addChatMessageEffectSaga);
  yield takeLatest(types.GET_OLD_MESSAGES, getOldMessagesEffectSaga);
  yield takeLatest(types.UPDATE_UNSEEN_CHAT, updateUnseenChatEffectSaga);
  yield takeLatest(types.END_CHAT_SESSION, endChatSessionEffectSaga);
}
